// tslint:disable
import { ZendeskModel } from './zendesk.model';
import * as i0 from "@angular/core";
import * as i1 from "./zendesk.model";
function getWindow() {
    return window;
}
export class ZendeskService {
    constructor(zendeskConfig) {
        if (!zendeskConfig.accountUrl) {
            throw new Error('Missing accountUrl. Please set in app config via ZendeskWidgetProvider');
        }
        this.window = getWindow();
        let window = this.window;
        // Following is essentially a copy paste of JS portion of the Zendesk embed code
        // with our settings subbed in. For more info, see:
        // https://support.zendesk.com/hc/en-us/articles/203908456-Using-Web-Widget-to-embed-customer-service-in-your-website
        window.zEmbed || function (e, t) {
            var n, o, d, i, s, a = [], r = document.createElement("iframe");
            window.zEmbed = function () {
                a.push(arguments);
            }, window.zE = window.zE || window.zEmbed,
                r.src = "javascript:false",
                r.title = "",
                r.style.cssText = "display: none",
                d = document.getElementsByTagName("script"),
                d = d[d.length - 1],
                d.parentNode.insertBefore(r, d),
                i = r.contentWindow,
                s = i.document;
            try {
                o = s;
            }
            catch (e) {
                n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);',
                    o = s;
            }
            o.open()._l = function () {
                var e = this.createElement("script");
                n && (this.domain = n),
                    e.id = "js-iframe-async",
                    e.src = "https://assets.zendesk.com/embeddable_framework/main.js",
                    this.t = +new Date,
                    this.zendeskHost = zendeskConfig.accountUrl,
                    this.zEQueue = a,
                    this.body.appendChild(e);
            },
                o.write('<body onload="document._l();">'),
                o.close();
        }();
        this.window.zE(() => {
            zendeskConfig.beforePageLoad(this.window.zE);
        });
    }
    setLocale(locale) {
        this.window.zE(() => {
            this.window.zE.setLocale(locale);
        });
    }
    identify(userObj) {
        this.window.zE(() => {
            this.window.zE.identify(userObj);
        });
    }
    hide() {
        this.window.zE(() => {
            this.window.zE.hide();
        });
    }
    show() {
        this.window.zE(() => {
            this.window.zE.show();
        });
    }
    activate(options) {
        this.window.zE(() => {
            this.window.zE.activate(options);
        });
    }
    setHelpCenterSuggestions(options) {
        this.window.zE(() => {
            this.window.zE.setHelpCenterSuggestions(options);
        });
    }
    setSettings(settings) {
        this.window.zESettings = settings;
    }
}
ZendeskService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ZendeskService_Factory() { return new ZendeskService(i0.ɵɵinject(i1.ZendeskModel)); }, token: ZendeskService, providedIn: "root" });
